import type React from 'react';

import { observer } from 'mobx-react';

import NestedListList from '../../../../common/controls/list';
import type { IProps as IListProps } from '../../../../common/controls/list';

export interface IProps extends IListProps {}

const NestedPageSublist: React.FC<IProps> = observer(({ onAdd, onBlur }) => {
  return (
    <div className="nested-item nowrap flex-row pl-[30px]">
      <div className="flex-both">
        <NestedListList onAdd={onAdd} onBlur={onBlur} />
      </div>
    </div>
  );
});

NestedPageSublist.displayName = 'NestedPageSublist';

export default NestedPageSublist;
